module.exports = __webpack_public_path__ + "static/media/ibd_shoulder2.feb8ac72.png";